export function isWindow(obj: any): boolean {
    return obj != null && obj === obj.window;
}
